import { IconSvgElement } from "@hugeicons/react";
import { useUnreadConversationsCount } from "views/inbox/api/use-unread-conversations-count";
import { NavLink } from "./NavLink";

const MAX_BADGE_COUNT = 99;

const formatBadgeCount = (count: number) =>
  count > MAX_BADGE_COUNT ? `${MAX_BADGE_COUNT}+` : String(count);

interface InboxNavLinkProps {
  name: string;
  to: string;
  Icon: IconSvgElement;
}

export const InboxNavLink = ({ name, to, Icon }: InboxNavLinkProps) => {
  const { unreadConversations } = useUnreadConversationsCount();

  return (
    <NavLink
      to={to}
      HugeIcon={Icon}
      indicator={
        unreadConversations > 0
          ? formatBadgeCount(unreadConversations)
          : undefined
      }
    >
      {name}
    </NavLink>
  );
};
